
import Header from "./header.jsx";
import ProductPage from "./product-page.jsx";
import { Router, Route, Routes } from "react-router-dom";
import Camp from "./camp.jsx";
import Home from "./home.js";
import Footer from "./footer.jsx";
import SupportForm from "./SupportForm.jsx";
import Mobile from "./mobile.jsx";




function App1() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/camp" element={<Camp />} />
        <Route path="/footer" element={<Footer />} />
        <Route path="/SupportForm" element={<SupportForm />} />
        <Route path="/mobile" element={<Mobile />} />

      </Routes>
      {/* <div className="App"> */}
      {/* <div className="Appbackgroundcolor"> */}
      {/* <div  className="header-main"> */}
      {/* <Header/> */}
      {/* </div> */}
      {/* <div> */}
      {/* <ProductPage/> */}
      {/* </div> */}
      {/* <div> */}
      {/* <footer className="fl-page-footer-wrap" itemScope="itemScope" itemtype="https://schema.org/WPFooter"> */}
      {/* First section with newsletter */}
      {/* <div className="fl-page-footer"> */}
      {/* <div className="fl-page-footer-container container form-container"> */}
      {/* <div className="intro"><p>Receive the latest news, tips, and product information!</p></div> */}
      {/* Uncomment iframe and script if necessary */}
      {/* <iframe src="https://go.illuminateed.com/l/124881/2022-08-04/qkcdpn" width="100%" height="125" type="text/html" frameborder="0" allowTransparency="true" style={{ border: 0 }}></iframe> */}
      {/* <script src="//info.renaissance.com/js/forms2/js/forms2.min.js"></script>
    <form id="mktoForm_1007"></form>
    <script>MktoForms2.loadForm("//info.renaissance.com", "237-RBJ-385", 1007);</script> */}
      {/* </div> */}
      {/* </div> */}

      {/* Second section with footer navigation and contact info */}
      {/* <div className="fl-page-footer"> */}
      {/* <div className="fl-page-footer-container container"> */}
      {/* <div className="fl-page-footer-row row"> */}
      {/* Footer navigation */}
      {/* <div className="col-sm-9 col-md-9 text-left clearfix">
        <ul id="menu-footer-nav-1" className="fl-page-footer-nav nav navbar-nav menu">
          <li id="menu-item-4957" className="menu-item nav-item">
            <a href="#" className="nav-link">Our Story</a>
          </li>
          <li id="menu-item-4949" className="menu-item nav-item">
            <a href="#" className="nav-link">News</a>
          </li>
          <li id="menu-item-5755" className="menu-item nav-item">
            <a href="#" className="nav-link">Webinars</a>
          </li>
          <li id="menu-item-4951" className="menu-item nav-item">
            <a href="#" className="nav-link">Events</a>
          </li>
          <li id="menu-item-5756" className="menu-item nav-item">
            <a href="#" className="nav-link">Partner Program</a>
          </li>
          <li id="menu-item-4952" className="menu-item nav-item">
            <a href="#" className="nav-link">Careers</a>
          </li>
          <li id="menu-item-4954" className="menu-item nav-item">
            <a href="#" className="nav-link">Resource Library</a>
          </li>
          <li id="menu-item-4955" className="menu-item nav-item">
            <a href="#" className="nav-link">Security & Privacy</a>
          </li>
        </ul>
      </div> */}

      {/* Contact Info */}
      {/* <div className="col-sm-3 col-md-3 text-right clearfix"> */}
      {/* <div className="fl-page-footer-text fl-page-footer-text-2"> */}
      {/* <strong>CONTACT US</strong> */}
      {/* <br /> */}
      {/* 1st Cross St */}
      {/* <br /> */}
      {/* S S Circle, Ashok Nagar */}
      {/* <br /> */}
      {/* Tumkuru 572103 */}
      {/* <br /> */}
      {/* +91 7795558001 */}
      {/* <br /> */}
      {/* <a href="https://www.technotharanga.com/" style={{color:"white"}}>www.technotharanga.com</a> */}
      {/* <br /> */}
      {/* <a href="mailto:technotharanga@gmail.com" style={{color:"white"}}>technotharanga@gmail.com</a> */}
      {/* <div className="fl-social-icons"> */}
      {/* <a href="#" className="fa-stack icon-facebook-f" target="_self" rel="noopener noreferrer"> */}
      {/* <span className="sr-only">Facebook</span> */}
      {/* <i aria-hidden="true" className="fas fa-circle fa-stack-2x mono"></i> */}
      {/* <i aria-hidden="true" className="fab fa-facebook-f mono fa-stack-1x fa-inverse"></i> */}
      {/* </a> */}
      {/* <a href="#" className="fa-stack icon-twitter" target="_self" rel="noopener noreferrer"> */}
      {/* <span className="sr-only">Twitter</span> */}
      {/* <i aria-hidden="true" className="fas fa-circle fa-stack-2x mono"></i> */}
      {/* <i aria-hidden="true" className="fab fa-twitter mono fa-stack-1x fa-inverse"></i> */}
      {/* </a> */}
      {/* <a href="#" className="fa-stack icon-linkedin" target="_self" rel="noopener noreferrer"> */}
      {/* <span className="sr-only">Linkedin</span> */}
      {/* <i aria-hidden="true" className="fas fa-circle fa-stack-2x mono"></i> */}
      {/* <i aria-hidden="true" className="fab fa-linkedin mono fa-stack-1x fa-inverse"></i> */}
      {/* </a> */}
      {/* <a href="#" className="fa-stack icon-youtube" target="_self" rel="noopener noreferrer"> */}
      {/* <span className="sr-only">Youtube</span> */}
      {/* <i aria-hidden="true" className="fas fa-circle fa-stack-2x mono"></i> */}
      {/* <i aria-hidden="true" className="fab fa-youtube mono fa-stack-1x fa-inverse"></i> */}
      {/* </a> */}
      {/* <a href="#" className="fa-stack icon-instagram" target="_self" rel="noopener noreferrer"> */}
      {/* <span className="sr-only">Instagram</span> */}
      {/* <i aria-hidden="true" className="fas fa-circle fa-stack-2x mono"></i> */}
      {/* <i aria-hidden="true" className="fab fa-instagram mono fa-stack-1x fa-inverse"></i> */}
      {/* </a> */}
      {/* </div> */}
      {/* </div> */}
      {/* </div> */}
      {/* </div> */}
      {/* </div> */}
      {/* </div> */}

      {/* Copyright Section */}
      {/* <div className="fl-page-footer"> */}
      {/* <div className="fl-page-footer-container container form-container"> */}
      {/* <div className="copyright"> */}
      {/* &copy; Copyright 2025 SchoolWave. All rights reserved. */}
      {/* <br /> */}
      {/* </div> */}
      {/* </div> */}
      {/* </div> */}
      {/* </footer> */}

      {/* </div> */}
      {/* </div> */}

      {/* </div> */}

    </>


  );
}

export default App1;
